/********* LIST *********/

export const GET_ADDITIONAL_FEE_LIST = 'GET_ADDITIONAL_FEE_LIST'
export const GET_ADDITIONAL_FEE_LIST_OK = 'GET_ADDITIONAL_FEE_LIST_OK'
export const GET_ADDITIONAL_FEE_LIST_ERR = 'GET_ADDITIONAL_FEE_LIST_ERR'
export const DO_ADDITIONAL_FEE_LIST_CLEANUP = 'DO_CLEANUP_ADDITIONAL_FEE'